// Official FamChest brand assets.
//
// The canonical logo pack lives in this app's `public/assets/famchest/`
// directory. The artwork was originally produced for the FamChest
// e-commerce storefront (../famchest-ecommerce/public/assets/famchest/)
// and is shared across all FamChest properties so a brand refresh stays
// in sync. The frontend points at the local copies served from the
// static host — no external CDN dependency, no per-build fingerprint
// churn.

const ASSETS = "/assets/famchest";

export const brandAssets = {
  /**
   * Square brand mark used by the nav rail header and app icon. A
   * 636×636 square crop of the heart mark from logo.png (the lockup
   * itself is a wide 1569×612 icon + wordmark combo), so it fits
   * icon slots without squishing.
   */
  icon: `${ASSETS}/icon.png`,
  /** White version of the square heart mark, for dark/rose surfaces. */
  iconMono: `${ASSETS}/icon-mono.png`,
  /** Full-color wordmark for light surfaces (navbar, default footer). */
  logoLarge: `${ASSETS}/logo.png`,
  /** Compact color wordmark for dense layouts. The storefront only ships
   * one color mark, so this alias keeps existing call sites working. */
  logoSmall: `${ASSETS}/logo.png`,
  /** White / monochrome wordmark for the rose primary footer band. */
  logoMono: `${ASSETS}/logo-mono.png`,
  /** Browser-tab favicon (also referenced from <link rel="icon">). */
  favicon: `${ASSETS}/icon.png`,
  /** App landing hero photograph (storefront's `store-hero.jpg`). */
  hero: `${ASSETS}/store-hero.jpg`,
 /**
   * Family-life photograph used by the About and Story sections. The
   * storefront doesn't expose a dedicated /about asset, so we reuse the
   * hero photograph — it's the same canonical family-life image set.
   */
  about: `${ASSETS}/store-hero.jpg`,
  /** Decorative heart / care emblem used on the landing page. The
   * storefront doesn't ship a separate heart PNG, so we alias the color
   * wordmark; the icon mark (`BrandMark`) renders the heart inline via
   * lucide-react where a true emblem is required. */
  heart: `${ASSETS}/logo.png`,
} as const;